<app-content-loading [isLoading]="isLoading">
    <div class="flex flex-col gap-5">
        @for (category of items$ | async; track category) {
            <app-fieldset
                [legend]="'translate_category_' + category.id | translate"
            >
                <div
                    class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3"
                >
                    @for (
                        item of category.permissions;
                        track trackByPermissionId($index, item)
                    ) {
                        <label
                            for="{{ item.permission.id }}"
                            class="group flex items-start gap-3 rounded-xl border p-4 transition-all"
                            [ngClass]="{
                                'cursor-pointer border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm':
                                    !item.checked && !item.disabled,
                                'cursor-pointer border-primary-300 bg-primary-50 shadow-sm':
                                    item.checked && !item.disabled,
                                'cursor-not-allowed border-slate-200 bg-slate-50 opacity-50':
                                    item.disabled,
                            }"
                        >
                            <input
                                type="checkbox"
                                class="hidden"
                                id="{{ item.permission.id }}"
                                [checked]="item.checked"
                                (click)="onCheckboxClick($event, item)"
                                [disabled]="item.disabled"
                            />
                            <!-- Custom checkbox indicator -->
                            <div
                                class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 transition-all"
                                [ngClass]="{
                                    'border-slate-300 bg-white': !item.checked,
                                    'border-primary-500 bg-primary-500':
                                        item.checked,
                                }"
                            >
                                @if (item.checked) {
                                    <i
                                        class="fa-solid fa-check text-[10px] text-white"
                                    ></i>
                                }
                            </div>
                            <!-- Permission info -->
                            <div class="flex min-w-0 flex-col gap-0.5">
                                <span
                                    class="text-sm font-medium"
                                    [ngClass]="{
                                        'text-slate-700': !item.checked,
                                        'text-primary-800': item.checked,
                                    }"
                                >
                                    {{ item.permission.name }}
                                </span>
                                @if (item.permission.description) {
                                    <span
                                        class="text-xs leading-relaxed text-slate-500"
                                    >
                                        {{ item.permission.description }}
                                    </span>
                                }
                            </div>
                        </label>
                    }
                </div>
            </app-fieldset>
        }
    </div>
</app-content-loading>
